import * as yup from "yup";
import type { TFunction } from "i18next";
import type { TipoDocumentoPersonalEnum } from "@/shared/types/enums/TipoDocumentoPersonal.enum";

export interface CargarDocumentoPersonalFormValues {
    type: TipoDocumentoPersonalEnum | null;
    file: File | null;
}

interface CargarDocumentoPersonalSchemaParams {
    t: TFunction;
    /** `true` cuando se edita un documento existente */
    esEdicion: boolean;
    /** Tipos de documento que el usuario ya tiene registrados */
    tiposRegistrados: TipoDocumentoPersonalEnum[];
}

/**
 * Esquema del formulario de carga de documento personal.
 * El tamaño y el formato del archivo se validan al seleccionarlo, para no aceptar archivos inválidos en el formulario.
 */
export const CargarDocumentoPersonalSchema = ({ t, esEdicion, tiposRegistrados }: CargarDocumentoPersonalSchemaParams) =>
    yup.object({
        type: yup
            .mixed<TipoDocumentoPersonalEnum>()
            .nullable()
            .defined()
            .test('required', t('errors.typeRequired'), (value) => value != null)
            .test('duplicate', t('errors.duplicateType'), (value) => esEdicion || value == null || !tiposRegistrados.includes(value)),
        /* El endpoint siempre requiere Base64, por lo que en edición también se exige un archivo nuevo */
        file: yup
            .mixed<File>()
            .nullable()
            .defined()
            .test('required', esEdicion ? t('errors.replaceFileRequired') : t('errors.fileRequired'), (value) => value != null),
    });
